import { render } from "./departement.vue?vue&type=template&id=6197e575"
import script from "./departement.vue?vue&type=script&lang=js"
export * from "./departement.vue?vue&type=script&lang=js"

import "./departement.vue?vue&type=style&index=0&id=6197e575&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__